import React from 'react';

import { useConversation } from './hooks';
import { closedTicketStatuses } from 'modules/chat/Conversation/constants';
import { ContainerStyled } from './styled';
import MessageList from './MessageList';
import SendMessage from './SendMessage';
import Header from './Header';

const Conversation = ({ driverName, conversationId, journeyId }) => {
  const { messages, status, loading, sendingMessage, handleSendMessage, handleCreateConversation } =
    useConversation(conversationId, journeyId);

  return (
    <ContainerStyled>
      <Header conversationId={conversationId} driverName={driverName} />
      <MessageList
        status={status}
        messages={messages}
        loading={!journeyId || loading}
        isStarted={!!conversationId}
        handleCreateConversation={handleCreateConversation}
      />
      {!closedTicketStatuses.includes(status) && (
        <SendMessage
          handleSendMessage={handleSendMessage}
          loading={loading}
          isStarted={!!conversationId}
          isSending={sendingMessage}
        />
      )}
    </ContainerStyled>
  );
};

export default Conversation;
